import React, { useRef, useState, useLayoutEffect } from 'react'
import { Box, Stack } from '@mantine/core'
import StackedBar from './StackedBar'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Cell, LabelList, ResponsiveContainer } from 'recharts';
import { getHardcodedColor, toPercentage } from '../../utils';

interface BarChartHeaderProp {
    data: {[key: string]: number};
    height: number;
    title?: string;
}

export const BarChartHeader: React.FC<BarChartHeaderProp> = ({ data, height = 50, title = "Detailed Score" }) => {
    const transData = Object.entries(data).map(([key, value]) => ({name: key, value: value}))
    return (
        <Stack style={{ width: "200px"  }} gap={0}>
            <div style={{ fontWeight: 'bold', height: "30%", marginLeft:5}}>{title}</div>
            <div style={{ height: "70%"}}>
                <ResponsiveContainer height="100%">
                    <BarChart data={transData} barGap={0} barCategoryGap="0%" title={title}>
                        <XAxis dataKey="name" hide />
                        <YAxis hide padding={{ top: 10}}  />
                        <CartesianGrid vertical={false} horizontal={false} />
                        <Bar dataKey="value">
                            {
                                transData.map((d, i) => (
                                    <Cell key={`cell-${i}`} fill={getHardcodedColor(d.name)} />
                                ))
                            }
                            <LabelList dataKey="value" position="inside" fontSize={12} formatter={toPercentage} fill='white'/>
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </Stack>
    );
}

interface StackedBarCellProps {
    data: {[key: string]: number}[]
    showValues?: boolean
    domain: [number, number]
    style?: {}
}

export const StackedBarCell: React.FC<StackedBarCellProps> = ({ data, showValues = true, domain, style = undefined }) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [dimensions, setDimensions] = useState({ width: 0, height: 30 * data.length }) // TODO: refactor

    useLayoutEffect(() => {
        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                setDimensions({
                    ...dimensions,
                    width: entry.contentRect.width
                });
            }
        });
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return () => {
            if (containerRef.current) observer.unobserve(containerRef.current);
        };
    }, [])

    return (
        <Box ref={containerRef} style={{ width: '100%', height: 20 * data.length, ...style }}>
            {dimensions.width > 0 && (
                <StackedBar
                    data={data}
                    cwidth={dimensions.width}
                    cheight={20 * data.length}
                    domain={domain}
                    showValues={showValues}
                />
            )}
        </Box>
    );
}